"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Configuration;

var _immutable = _interopRequireDefault(require("immutable"));

var defaultState = _immutable.default.Map({
  withShutterstock: false,
  uploadedFileAccess: null
});

function Configuration() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  return state;
}

module.exports = exports.default;